import { api } from "./VaultApi";

const apiUrl = process.env.REACT_APP_API_URL;

const getUserId = () => {
  return (
    sessionStorage.getItem("USER_ID") ||
    localStorage.getItem("USER_ID") ||
    "0001"
  );
};

export const GetAdminDashboardData = async () => {
  try {
    // const response = await api.get(`${apiUrl}/admin_dashboard/${getUserId()}`);
    const response = await api.get(`${apiUrl}/admin_dashboard`);
    return response?.data || null;
  } catch (error) {
    console.error("Dashboard API Error:", error);
    return null;
  }
};